import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GLPIComponent } from './glpi.component';


@NgModule({
    declarations: [GLPIComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NzUploadModule,
        NzIconModule,
        NzInputModule,
        MatFormFieldModule
    ],
    exports: [GLPIComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GlpiModule { }
